import React from "react";
import { Modal } from "antd";
const ModalComponent = (props) => {
  const {
    title,
    showModal,
    content,
    onOk,
    onCancel,
    width,
    footer,
    closeIcon,
  } = props;

  return (
    <>
      <Modal
        destroyOnClose={true}
        title={title}
        centered
        open={showModal}
        onOk={onOk}
        onCancel={onCancel}
        onClose={onCancel}
        width={width || 800}
        footer={footer}
        closeIcon={closeIcon}
        maskClosable={false}
      >
        {content}
      </Modal>
    </>
  );
};
export default ModalComponent;
